import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "D:/Documents/React Projects/components/react-mui-draft-wysiwyg/node_modules/gatsby-theme-docz/src/base/Layout.js";
import MUIEditor, { MUIEditorState } from "../../src";
import { Playground } from "docz";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <blockquote>
      <p parentName="blockquote">{`Initializes the editor with empty content`}</p>
    </blockquote>
    <h2 {...{
      "id": "imports"
    }}>{`Imports`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`import MUIEditor, { MUIEditorState } from "react-mui-draft-wysiwyg";
`}</code></pre>
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <Playground __position={0} __code={'() => {\n  const [editorState, setEditorState] = React.useState(\n    MUIEditorState.createEmpty(),\n  )\n  const onChange = newState => {\n    setEditorState(newState)\n  }\n  return <MUIEditor editorState={editorState} onChange={onChange} />\n}'} __scope={{
      props,
      DefaultLayout,
      MUIEditor,
      MUIEditorState,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const [editorState, setEditorState] = React.useState(MUIEditorState.createEmpty());

        const onChange = newState => {
          setEditorState(newState);
        };

        return <MUIEditor editorState={editorState} onChange={onChange} mdxType="MUIEditor" />;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      